module.exports = __webpack_public_path__ + "img/DK39178443.ed1f1aca.png";